<template v-if="modelType">
    <ImageModel2 :slow="0" :model="model" :blue="blue" @result="resultEvt" :purple="purple" :file="file" v-if="model && modelType =='image'"/>
    <PoseModel2 :slow="0" :model="model" :blue="blue" @result="resultEvt" :purple="purple" :file="file" v-if="model && modelType=='pose'"/>
    <AudioModel2 :slow="0" :model="model" :blue="blue" @result="resultEvt" :purple="purple" :file="file" v-if="model && modelType=='speech'"/>
    <span style="width: 100%; height: 10px;" v-if="modelType != 'skip'" />
    <div style="width: 250px; display: flex; flex-direction: column; max-height: 200px; overflow-y: auto; z-index: -1;">
        <ModelResult v-if="result" :result="result" />
        <slot />
    </div>
</template>

<script>
import ModelResult from '@/tm/ModelResult'
import ImageModel2 from '@/tm/ImageModel2'
import PoseModel2 from '@/tm/PoseModel2'
import AudioModel2 from '@/tm/AudioModel2'
import Box from '@/ui/Box'

export default {
    emits: ['result'],
    props:{
        modelType: {
            type: String,
            default: null
        },
        model:{
            type: Object,
            default: null
        },
        file: {
            type: Boolean,
            default: false
        },
        purple: {
            type: Boolean,
            default: false
        },
        blue: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Box,
        ModelResult,
        ImageModel2,
        PoseModel2,
        AudioModel2,
    },
    data(){
        return{
            result: null,
            slow: 0,
        }
    },
    methods:{
        resultEvt(result, canvas){
            if (result) {
                const index = result.findIndex(_class => _class.probability > 0.5);
                if (index != -1) {
                    this.$emit("result", "class", index, canvas, result)
                }
                this.result = result
            }
        },
        setSlow(){
            this.slow = 3
        },
        setNormal(){
            this.slow = 0;
        }
    },
    mounted(){
        addEventListener("scroll", this.setSlow, { passive: true });
        addEventListener("scrollend", this.setNormal, { passive: true });
    },
    unmounted(){
        removeEventListener("scroll", this.setSlow)
        removeEventListener("scrollend", this.setNormal)
    }
}
</script>